import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { arrayOf, bool, func, shape, string, object } from "prop-types";
import { Link } from "react-router-dom";
import ReadingStatus from "../ReadingListDownload/reading_status";
import { filenameFromUrl } from "../../common/OnboardingSectionCreator/helpers";
import {
  markDocumentReadThanetCouncil,
  postRiskAssessmentThanetCouncil,
} from "../../redux/actions/index";
import OnboardingSection from "../../common/OnboardingSectionCreator/OnboardingSection";
import OnboardingListItem from "../OnboardingListItem/OnboardingListItem";
import ReadingListDownload from "../ReadingListDownload/index";
import * as myStyles from "./styles.module.scss";
import * as style from "../ReadingListDownload/styles.module.scss";

const ThanetCouncilOnboarding = ({
  thanetCouncilOnboarding,
  readingListDownloads,
  readingLoading,
  markDocumentRead,
  postRiskAssessment,
  riskAssessmentDriverDocs,
  riskAssessmentNonDriverDocs,
  riskAssessmentLoading,
}) => {
  const [currentlyReading, setCurrentlyReading] = useState(null);
  const [content, showContent] = useState("");
  const [contentList, showContentList] = useState("");
  const [showCheckbox, setShowCheckbox] = useState("");
  useEffect(() => {}, [showCheckbox, currentlyReading]);

  const readDocuments =
    (thanetCouncilOnboarding && thanetCouncilOnboarding.readDocuments) || [];

  const riskAssessmentDriver =
    (thanetCouncilOnboarding && thanetCouncilOnboarding.riskAssessmentDriver) ||
    [];

  const riskAssessmentNonDriver =
    (thanetCouncilOnboarding &&
      thanetCouncilOnboarding.riskAssessmentNonDriver) ||
    [];

  const formsListWithStatus = [
    {
      status:
        thanetCouncilOnboarding && thanetCouncilOnboarding.benefitsDeclaration
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Benefits Declaration",
      url: "thanet-council-onboarding/benefits-declaration",
      text: "Complete",
      submitted: !!(
        thanetCouncilOnboarding && thanetCouncilOnboarding.benefitsDeclaration
      ),
    },
    {
      status:
        thanetCouncilOnboarding && thanetCouncilOnboarding.dvlaCheckAndSignature
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "DVLA Check",
      description: "Only complete if you are applying for a driving role",
      url: "thanet-council-onboarding/dvla-check-and-signature",
      text: "Complete",
      submitted: !!(
        thanetCouncilOnboarding && thanetCouncilOnboarding.dvlaCheckAndSignature
      ),
    },
    {
      status:
        thanetCouncilOnboarding && thanetCouncilOnboarding.driverDeclaration
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Driver Declaration",
      description: "Only complete if you are applying for a driving role",
      url: "thanet-council-onboarding/driver-declaration",
      text: "Complete",
      submitted: !!(
        thanetCouncilOnboarding && thanetCouncilOnboarding.driverDeclaration
      ),
    },
    {
      status:
        thanetCouncilOnboarding && thanetCouncilOnboarding.inductionSignoff
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Induction Signoff",
      url: "thanet-council-onboarding/induction-signoff",
      text: "Complete",
      submitted: !!(
        thanetCouncilOnboarding && thanetCouncilOnboarding.inductionSignoff
      ),
    },
    {
      status:
        thanetCouncilOnboarding && thanetCouncilOnboarding.YTDO
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Onboarding Questions (Stage 1)",
      url: "thanet-council-onboarding/questions-stage1",
      text: "Complete",
      submitted: !!(thanetCouncilOnboarding && thanetCouncilOnboarding.YTDO),
    },
    {
      status:
        thanetCouncilOnboarding && thanetCouncilOnboarding.shiftInduction
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Shift Induction",
      url: "thanet-council-onboarding/shift-induction",
      text: "Complete",
      submitted: !!(
        thanetCouncilOnboarding && thanetCouncilOnboarding.shiftInduction
      ),
    },
  ];

  const readingListWithStatus = readingListDownloads
    .map((download) => ({
      ...download,
      status: readDocuments.includes(filenameFromUrl(download.link))
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
    }))
    .sort((a, b) => a.title.localeCompare(b.title));

  const toolboxTalksContentList = [
    {
      line: "Drivers",
      contentToRead: [
        "1. Attitude and Behaviour",
        "2. Collection of Refuse Wheelie Bins",
        "3. What You Can or Cannot Collect",
        "4. Asbestos Awareness",
        "5. Common Sense and Accident Prevention",
        "6. Conflict Management",
        "7. Employee Responsibility",
        "9. Working Safely in The Rain",
        "10. Heat Stress",
        "11. The Importance of Hydration",
        "12. Personal Hygiene",
        "13. Personal Safety Considerations",
        "14. Personal Protective Equipment",
        "15. Winter Safety",
        "16. Personal Needlestick Injuries",
        "17. Situational Awareness",
        "18. The Three-Point Rule",
        "19. Preventing Back Injuries",
        "20. Helping You Manage Back Pain",
        "21. Animal Attack Prevention",
        "22. Unsafe Acts",
        "23. Workplace Rules",
        "24. Pinch Points",
        "25. Whole Body Vibration",
        "26. Vehicle Safety",
        "27. Check Your Vehicle",
        "28. Fleet Management Defecting",
        "29. Reversing",
        "30. Winter Driving",
        "31. Drive Defensively",
        "32. Road Traffic Incidents",
        "32. Site Safety Rules – Tipping Ling Metals Ltd",
        "33. Near Miss and Dangerous Occurrence Reporting",
      ],
      role: "drivers",
    },
    {
      line: "Dustcart Operatives",
      contentToRead: [
        "1. Attitude and Behaviour",
        "2. Collection of Refuse Wheelie Bins",
        "3. What You Can or Cannot Collect",
        "4. Asbestos Awareness",
        "5. Common Sense and Accident Prevention",
        "6. Conflict Management",
        "7. Employee Responsibility",
        "9. Working Safely in The Rain",
        "10. Heat Stress",
        "11. The Importance of Hydration",
        "12. Personal Hygiene",
        "13. Personal Safety Considerations",
        "14. Personal Protective Equipment",
        "15. Winter Safety",
        "16. Personal Needlestick Injuries",
        "17. Situational Awareness",
        "18. The Three-Point Rule",
        "19. Preventing Back Injuries",
        "20. Helping You Manage Back Pain",
        "21. Animal Attack Prevention",
        "22. Unsafe Acts",
        "23. Workplace Rules",
        "24. Pinch Points",
        "25. Whole Body Vibration",
        "33. Near Miss and Dangerous Occurrence Reporting",
      ],
      role: "dustcartOperatives",
    },
    {
      line: "Other",
      contentToRead: [
        "1. Attitude and Behaviour",
        "4. Asbestos Awareness",
        "5. Common Sense and Accident Prevention",
        "6. Conflict Management",
        "7. Employee Responsibility",
        "9. Working Safely in The Rain",
        "10. Heat Stress",
        "11. The Importance of Hydration",
        "12. Personal Hygiene",
        "13. Personal Safety Considerations",
        "14. Personal Protective Equipment",
        "15. Winter Safety",
        "16. Personal Needlestick Injuries",
        "17. Situational Awareness",
        "19. Preventing Back Injuries",
        "20. Helping You Manage Back Pain",
        "21. Animal Attack Prevention",
        "22. Unsafe Acts",
        "23. Workplace Rules",
        "33. Near Miss and Dangerous Occurrence Reporting",
      ],
      role: "other",
    },
  ];

  const docsToAlphabeticalOrder = (docs) =>
    docs.sort((a, b) => a.title.localeCompare(b.title));

  const listOfRiskAssessments = [
    {
      line: "Drivers",
      docs: docsToAlphabeticalOrder(riskAssessmentDriverDocs) || [],
      statusFor: riskAssessmentDriver,
      formName: "riskAssessmentDriver",
    },
    {
      line: "Non drivers",
      docs: docsToAlphabeticalOrder(riskAssessmentNonDriverDocs) || [],
      statusFor: riskAssessmentNonDriver,
      formName: "riskAssessmentNonDriver",
    },
  ];

  const currentDate = new Date(Date.now());
  const handleCheckbox = (formName, el) => {
    postRiskAssessment(formName, {
      [el.title]: currentDate.toISOString(),
    });
    setShowCheckbox("");
  };

  const isiOSDevice = () => {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  };
  const isDownloadAttrSupported = () =>
    "download" in document.createElement("a");

  const handleReading = (event, title, link) => {
    window.open(link, "_blank");
    if (isiOSDevice() || !isDownloadAttrSupported()) {
      event.preventDefault();
    }
    setShowCheckbox(title);
  };

  return (
    <div className="container text-bluishGray pb-2">
      <header className="row">
        <div className="col-12">
          <h2 className="section-header pt-2">
            Thanet District Council Onboarding
          </h2>
        </div>
      </header>
      <div className="row">
        <div className="col-lg-6">
          <div
            className={`${myStyles.readingList__wrapper} section-body pt-1 mb-1 bg-white`}
          >
            <h5 className="px-1">Toolbox Talks</h5>
            <p className="p-1" style={{ width: "90%" }}>
              You are required to download and read the document below before
              you start work. Please only read the sections in the document
              related to your role indicated in the contents list. If you have
              any queries about the document, please speak to your HRGO
              Consultant.
            </p>
            {readingListWithStatus
              .filter((elem) => elem.title === "Toolbox Talks")
              .map((elem, i) => (
                <ReadingListDownload
                  key={i}
                  title={elem.title}
                  link={elem.link}
                  status={elem.status}
                  agreementText={elem.agreementText}
                  currentlyReading={currentlyReading}
                  setCurrentlyReading={setCurrentlyReading}
                  markDocumentRead={markDocumentRead}
                  isLoading={readingLoading}
                />
              ))}
            <h5 className="p-1">Contents List</h5>
            {toolboxTalksContentList.map((el) => (
              <Fragment key={el.role}>
                <div
                  style={{
                    fontWeight: "600",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className="styles__onboarding__wrapper___3a5Dz items-center flex-row mb6-0 px-1"
                  onClick={() =>
                    showContentList(contentList === el.line ? "" : el.line)
                  }
                >
                  <p>{el.line}</p>

                  <img
                    style={{ margin: "8px" }}
                    src="https://www.hrgo.co.uk/images/nav/nav-arrow-down.svg"
                    className={`${
                      contentList === el.line && style.rotateimg180
                    }`}
                    width="10px"
                    height="10px"
                    alt="arrow-down"
                  />
                </div>
                {contentList === el.line &&
                  el.contentToRead.map((element, index) => {
                    return (
                      <p key={index} className="px-1">
                        {element}
                      </p>
                    );
                  })}
              </Fragment>
            ))}
          </div>

          <div
            className={`${myStyles.readingList__wrapper} section-body pt-1 mt-1  bg-white`}
          >
            <h5 className="px-1">Staff Induction Booklet</h5>
            <p className="p-1" style={{ width: "90%" }}>
              Please download and read the Staff Induction Booklet and tick the
              box to confirm you have read and understood and agree to the
              booklet. If you have any queries about the booklet, please speak
              to your HRGO Consultant.
            </p>
            {readingListWithStatus
              .filter((elem) => elem.title === "Staff Induction Booklet")
              .map((elem, i) => (
                <ReadingListDownload
                  key={i}
                  title={elem.title}
                  link={elem.link}
                  status={elem.status}
                  agreementText={elem.agreementText}
                  currentlyReading={currentlyReading}
                  setCurrentlyReading={setCurrentlyReading}
                  markDocumentRead={markDocumentRead}
                  isLoading={readingLoading}
                />
              ))}
          </div>
        </div>
        <div className="col-lg-6">
          <OnboardingSection
            title="Documents to Complete"
            subtext="Please complete all of the below forms. Once you have submitted your forms you will be
                    unable to edit them. If you have any queries about the forms,
                    please speak to your HRGO Consultant."
            formsListWithStatus={formsListWithStatus}
            submit={() => {}}
          />
          <div
            className={`${myStyles.readingList__wrapper} section-body pt-1 mt-1 bg-white`}
          >
            <h5 className="px-1">Risk Assessments</h5>
            <p className="px-1">
              Please only read the documents related to your role.
            </p>
            {listOfRiskAssessments.map((el) => (
              <Fragment key={el.formName}>
                <div
                  style={{
                    fontWeight: "700",
                    cursor: "pointer",
                    padding: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className="styles__onboarding__wrapper___3a5Dz items-center flex-row mb6-0"
                  onClick={() =>
                    showContent(content === el.line ? "" : el.line)
                  }
                >
                  <p>{el.line}</p>

                  <img
                    style={{ margin: "8px" }}
                    src="https://www.hrgo.co.uk/images/nav/nav-arrow-down.svg"
                    className={`${content === el.line && style.rotateimg180}`}
                    width="10px"
                    height="10px"
                    alt="arrow-down"
                  />
                </div>
                {content === el.line &&
                  el.docs.map((element, index) => {
                    return showCheckbox === element.title ? (
                      <div
                        key={index}
                        className={`${style.rldownload__wrapper} ${style.rldownload__wrapper__reading}`}
                      >
                        <span className={style.rldownload__agreement}>
                          <input
                            type="checkbox"
                            name="document_read"
                            value={element.title}
                            onClick={() => handleCheckbox(el.formName, element)}
                          />
                          {`I confirm that I have read and understood the ${element.title} Risk Assessment`}
                        </span>
                        <button
                          onClick={() => setShowCheckbox(null)}
                          className={`${style.rldownload__button} btn btn-md btn-outline mx-1 mx-sm-0`}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <OnboardingListItem
                        loading={riskAssessmentLoading === element.title}
                        title={element.title}
                        status={el.statusFor[element.title] ? 3 : 1}
                        key={index}
                        btnText="Download"
                        disabled={showCheckbox && showCheckbox.length > 1}
                        handleClick={(e) =>
                          handleReading(e, element.title, element.link)
                        }
                        downloadingDisabled={true}
                      />
                    );
                  })}
              </Fragment>
            ))}
          </div>
        </div>
      </div>

      <div
        className={`${myStyles.button__wrapper} d-flex justify-content-end mt-4`}
      >
        <Link to="/profile" className="btn btn-primary px-3">
          Back to My Account
        </Link>
      </div>
    </div>
  );
};

ThanetCouncilOnboarding.propTypes = {
  thanetCouncilOnboarding: object,
  readingListDownloads: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
      agreementText: string.isRequired,
    })
  ),
  riskAssessmentDriverDocs: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  riskAssessmentNonDriverDocs: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  postRiskAssessment: func.isRequired,
  markDocumentRead: func.isRequired,
  readingLoading: bool,
  riskAssessmentLoading: string,
};

const mapStateToProps = (state) => ({
  thanetCouncilOnboarding: state.core.app.thanetCouncilOnboarding,
  readingListDownloads: state.core.umbracoContent.thanetCouncilReadingList,
  readingLoading: state.core.thanetCouncilReading.isLoading,
  riskAssessmentLoading: state.core.thanetCouncilRiskAssesment.formName,
  riskAssessmentDriverDocs:
    state.core.umbracoContent.thanetCouncilRiskAssessmentDriver,
  riskAssessmentNonDriverDocs:
    state.core.umbracoContent.thanetCouncilRiskAssessmentNonDriver,
});

const mapDispatchToProps = {
  markDocumentRead: markDocumentReadThanetCouncil,
  postRiskAssessment: postRiskAssessmentThanetCouncil,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(ThanetCouncilOnboarding);
